module.exports = __webpack_public_path__ + "static/img/1099.f270cd3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1099.jpg
// module id = 281
// module chunks = 0